import { Module, MutationTree, GetterTree, ActionTree } from 'vuex'
import { RootState } from '@/store'

type tokenObj = {
  access_token?: string
  token_type?: string
  expires_in?: number
}

export type UserState = {
  token: tokenObj
  profile: object
  permisstion: object
}

const state: UserState = {
  token: {},
  profile: {},
  permisstion: {}
}

export enum UserGettersTypes {
  GET_TOKEN = 'GET_TOKEN',
  GET_PROFILE = 'GET_PROFILE',
  GET_PERMISSION = 'GET_PERMISSION',
  GET_SUPPLIER_LANGUAGE = 'GET_SUPPLIER_LANGUAGE'
}

export const getters: GetterTree<UserState, RootState> = {
  [UserGettersTypes.GET_TOKEN]: (state: UserState): object => {
    const token = state.token

    // 從 localStorage 拿 token
    // (ps: 為了預防雙開分頁, 頁1:登出再登入, 頁2:仍拿到舊的 toekn)
    const localToken = localStorage.getItem('token')

    // 從 localStorage 更新 token
    if (localToken && token.access_token !== localToken) {
      token.access_token = localToken
    }
    return token
  },
  [UserGettersTypes.GET_PROFILE]: (state: UserState): object => {
    return state.profile
  },
  [UserGettersTypes.GET_PERMISSION]: (state: UserState): object => {
    return state.permisstion
  },
  [UserGettersTypes.GET_SUPPLIER_LANGUAGE]: (state: UserState, getters: any): any => {
    return getters[UserGettersTypes.GET_PROFILE]?.supplier?.language || 1
  }
}

export enum UserMutationTypes {
  SET_TOKEN = 'SET_TOKEN',
  SET_PROFILE = 'SET_PROFILE',
  SET_PERMISSION = 'SET_PERMISSION'
}

export const mutations: MutationTree<UserState> = {
  [UserMutationTypes.SET_TOKEN] (state: UserState, payload: tokenObj): void {
    state.token = payload
    // 另外將 token 儲存至 localStorage
    if (payload.access_token) {
      // 登入
      localStorage.setItem('token', payload.access_token)
    } else {
      // 登出
      localStorage.removeItem('token')
    }
  },
  [UserMutationTypes.SET_PROFILE] (state: UserState, payload: object): void {
    state.profile = payload
  },
  [UserMutationTypes.SET_PERMISSION] (state: UserState, payload: object): void {
    state.permisstion = payload
  }
}

export enum AppActionsTypes {
  DO_LOGIN = 'DO_LOGIN'
}
export const actions: ActionTree<UserState, RootState> = {
  [AppActionsTypes.DO_LOGIN] ({ commit }, payload: string) {
    // todo
  }
}

export const user: Module<UserState, RootState> = { state, getters, mutations }
